/**
 * User Settings Model
 */

import type { UserSettingsInterface } from '@KTXC/types/user/userSettingsTypes';

export class UserSettings {
  private _data: UserSettingsInterface;

  constructor(data: UserSettingsInterface = {}) {
    this._data = data;
  }

  fromJson(data: UserSettingsInterface): UserSettings {
    this._data = data;
    return this;
  }

  toJson(): UserSettingsInterface {
    return { ...this._data };
  }

  clone(): UserSettings {
    return new UserSettings(JSON.parse(JSON.stringify(this._data)));
  }

  /**
   * Get a setting value
   */
  get(key: string): any {
    return this._data[key] ?? null;
  }

  /**
   * Set a setting value
   */
  set(key: string, value: any): void {
    this._data[key] = value;
  }

  /**
   * Check if a setting exists
   */
  has(key: string): boolean {
    return key in this._data;
  }

  /**
   * Get all settings
   */
  get all(): UserSettingsInterface {
    return this._data;
  }

  /**
   * Get multiple settings
   */
  getMany(keys: string[]): Record<string, any> {
    return keys.reduce((acc, key) => ({
      ...acc,
      [key]: this._data[key] ?? null
    }), {});
  }

  /**
   * Set multiple settings
   */
  setMany(settings: Record<string, any>): void {
    Object.entries(settings).forEach(([key, value]) => {
      this._data[key] = value;
    });
  }
}
